function MailIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 10C0 4.47715 4.47715 0 10 0V0C15.5228 0 20 4.47715 20 10V10C20 15.5228 15.5228 20 10 20V20C4.47715 20 0 15.5228 0 10V10Z"
        fill="#C4C4C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 6.5C2.5 5.82169 2.77423 5.5 3.5666 5.5H16.5C17.2143 5.5 17.5 5.81811 17.5 6.49999V14.5C17.5 15.2534 17.2308 15.5 16.5 15.5H3.5C2.74847 15.5 2.5 15.1966 2.5 14.5V6.5ZM3.5666 6.76984L9.65738 10.6853C10 10.9297 10 10.9258 10.3426 10.6853L16.4334 6.76984C16.4334 6.5 16.5 6.49999 16 6.5H4.07692C3.5666 6.5 3.5666 6.5 3.5666 6.76984ZM16.5 7.91583L10.8834 11.5265C10 12 10 12 9.11663 11.5265L3.5 7.91583V14C3.5 14.5 3.5 14.5 4.07692 14.5H15.9231C16.5 14.5 16.5 14.5 16.5 14V7.91583Z"
        fill="#272B2F"
      />
    </svg>
  )
}

export default MailIcon
